import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiFile3Line, RiFolderOpenLine } from 'react-icons/ri';

import MissionInfo from './01_MissionInfo';
import MissionBrowser from './02_MissionBrowser';
import FileTool from './03_FileTool';
import styles from './index.module.scss';

import Bar from '@/components/ui/Bar';

const cx = classNames.bind(styles);

const Sidebar = () => {
  const [isShowMissionBrowser, setShowMissionBrowser] = useState(false);

  const replaceToNew = () => {
    window.location.replace('/mission-hub/new');
  };

  const toggleMissionBrowser = () => {
    setShowMissionBrowser(!isShowMissionBrowser);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('groups')}>
        <Bar size={24} horizontal />
        <div className={cx('group')}>
          <div className={cx('button')} onClick={replaceToNew}>
            <RiFile3Line size={20} color="white" />
          </div>
          <div className={cx(['button', { active: isShowMissionBrowser }])} onClick={toggleMissionBrowser}>
            <RiFolderOpenLine size={20} color="white" />
          </div>
        </div>
        <Bar size={24} horizontal />
        <FileTool />
      </div>
      <Bar size={24} horizontal />

      {/* Panels */}
      <div className={cx(['panel', { active: !isShowMissionBrowser }])}>
        <MissionInfo />
      </div>
      <div className={cx(['panel', { active: isShowMissionBrowser }])}>
        <MissionBrowser active={isShowMissionBrowser} onDone={toggleMissionBrowser} />
      </div>
    </div>
  );
};

export default Sidebar;
